import {
  combineReducers,
  applyMiddleware,
  createStore,
  compose,
} from 'redux'
import thunk from 'redux-thunk'
import { Router } from 'router5'
import { router5Middleware } from 'redux-router5'

import { reducer as system } from './modules/system'
import { reducer as network } from './modules/network'
import { reducer as router } from './modules/router'
import { reducer as snackbar } from './modules/snackbar'

const coreReducers = {
  system,
  network,
  router,
  snackbar,
}

interface StoreProps {
  router: Router<Record<string, any>>,
  initialState: Record<string, any>,
  reducers: Record<string, any>,
}

const StoreFactory = ({
  router,
  initialState = {},
  reducers = {},
}: StoreProps): any => {

  const allReducers = Object.assign({}, reducers, coreReducers)

  const reducer = combineReducers(allReducers)
    
  let middleware = [
    router5Middleware(router),
    thunk,
  ]

  const storeEnhancers = [
    applyMiddleware(...middleware),
  ]

  if(window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) storeEnhancers.push((window as any).__REDUX_DEVTOOLS_EXTENSION__({
    shouldHotReload: false,
  }))

  const store = createStore(
    reducer,
    initialState,
    compose(...storeEnhancers) as any
  )

  router.setDependency('store', store)

  return store
}

export default StoreFactory